//@flow

import {
  createCategoryApi,
  deleteCategoryApi,
  editCategoryApi,
  listCategoriesApi,
  endpoints,
} from '../api/blog-category';

import type {BlogCategoryRequest} from '../api/blog-category';

import type {BlogCategory} from '../../../entities';
import {buildRoute} from '../../../http';

export function listBlogCategoriesService(): Promise<BlogCategory[]> {
  return listCategoriesApi().toPromise();
}

export function createBlogCategoryService(
  category: BlogCategoryRequest
): Promise<BlogCategory> {
  return createCategoryApi(category).toPromise();
}

export function editBlogCategoryService(
  id: string,
  category: BlogCategoryRequest
): Promise<BlogCategory> {
  const route = buildRoute(endpoints.EDIT_CATEGORY, [id]);
  return editCategoryApi(category, {route}).toPromise();
}

export function deleteBlogCategoryService(id: string): Promise<void> {
  const route = buildRoute(endpoints.DELETE_CATEGORY, [id]);
  return deleteCategoryApi({route}).toPromise();
}
